// extracted by mini-css-extract-plugin
export default {"permissionRoute":"permissionRoute_kboNb3ls","permissionRouteContainer":"permissionRouteContainer_yorAbry7"};